import { render, staticRenderFns } from "./GroupSettingPay.vue?vue&type=template&id=7bbffb38&"
import script from "./GroupSettingPay.vue?vue&type=script&lang=js&"
export * from "./GroupSettingPay.vue?vue&type=script&lang=js&"
import style0 from "./GroupSettingPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupSettingPay.vue"
export default component.exports